<ngx-loading-bar [color]="'#00a859'"> </ngx-loading-bar>
<router-outlet></router-outlet>
